import { FieldSet, Label, LabeledControl, Legend, Radio } from '@zillow/constellation-10';
import { WIZARD_SCREEN_TYPES } from '../../../constants/stringConstants';
import { useLeasingUrlParams } from '../../../hooks/useLeasingUrlParams';
import { useLeaseQuery } from '../../../utils/queries';

export default function WhatAreYourPlansWithYourCurrentTenants({ onRadioSelect }: { onRadioSelect }) {
  const { leaseId } = useLeasingUrlParams();

  const leaseQuery = useLeaseQuery(leaseId);

  const numberOfTenants = leaseQuery?.data?.tenants?.length;

  return (
    <FieldSet
      required
      legend={
        <Legend>
          {numberOfTenants > 1
            ? 'What are the plans with your current tenants?'
            : 'What are the plans with your current tenant?'}
        </Legend>
      }
    >
      <LabeledControl
        label={<Label>{numberOfTenants > 1 ? 'All are staying' : 'They are staying'}</Label>}
        control={
          <Radio
            name="plans-for-current-tenant"
            value={WIZARD_SCREEN_TYPES.WHAT_DO_YOU_WANT_TO_DO_WITH_YOUR_LEASE}
            onChange={onRadioSelect}
          />
        }
      />
      <LabeledControl
        label={<Label>Some are staying</Label>}
        disabled={numberOfTenants <= 1}
        control={
          <Radio
            name="plans-for-current-tenant"
            value={WIZARD_SCREEN_TYPES.WHAT_DO_YOU_WANT_TO_DO_WITH_YOUR_LEASE_NO_UPDATE}
            onChange={onRadioSelect}
          />
        }
      />
      <LabeledControl
        label={<Label>{numberOfTenants > 1 ? 'All are moving out' : 'They are moving out'}</Label>}
        control={
          <Radio
            name="plans-for-current-tenant"
            value={WIZARD_SCREEN_TYPES.HAVE_YOU_ALREADY_FOUND_YOUR_NEW_TENANTS}
            onChange={onRadioSelect}
          />
        }
      />
    </FieldSet>
  );
}
